import React, { useRef, useState } from "react";
import { FaRegWindowClose } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useForm } from "react-hook-form";
import { FirstUpperCase } from "../../../../services/Helpers/fonctions";
const OtherColors = ({ isOpen, setIsOpen, handleInput,paiement }) => {
    const modalRef = useRef(null);
    const [inputValue, setInputValue] = useState(paiement?.infovehicule?.otherColor);
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const closeModal = (e) => {
        if (modalRef.current === e.target) {
            setIsOpen(false);
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        
    };

    const addOtherColors = (data) => {
        const newOtherColors = FirstUpperCase (data.otherColor?.trim());
        if (newOtherColors) {
            if (handleInput) {
                const syntheticEvent = {
                    target: {   
                        name: "otherColor",
                        value: newOtherColors
                    }
                };
                handleInput(syntheticEvent);
            }
        }
        setIsOpen(false);
    };
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="modal-component" onClick={closeModal} ref={modalRef}>
                <motion.div 
                  initial={{ opacity: 0, top: "30%" }} 
                  animate={{ opacity: 1, top: "50%" }} 
                  transition={{ duration: 0.2 }} 
                  exit={{ opacity: 0, top: "10%" }}
                  className="modal"
                >
                  <div className="close" onClick={() => setIsOpen(false)}>
                    <FaRegWindowClose id="close-icon" />
                  </div>
                    <h4>Ajouter un chassis</h4>
                    <form onSubmit={handleSubmit(addOtherColors)}>
                        <div className="input-group">
                            <label>Autres couleurs
                                <input
                                    type="text"
                                    name="otherColor"
                                    value={FirstUpperCase(inputValue)}
                                    
                                    {...register("otherColor", {
                                        required: "Autres couleurs sont obligatoires",
                                        maxLength: {
                                            value: 20,
                                            message: "Autres couleurs ne peut pas dépasser 20 caractères"
                                        },
                                        onChange: (e) => handleInputChange(e)
                                    })}
                                />
                             {errors.otherColor && (    
                                <span className="error-msg">
                                    {errors.otherColor.message}
                                </span>
                             )}
                           </label>
                        </div>
                        <button type="submit">Ajouter</button>
                    </form>
                    
                </motion.div>
              </div>                    
            )}
        </AnimatePresence>
    );
}

export default OtherColors;